<template>
  <div class="list-cell-container">
    <div class="content">
      <p class="title">{{ title }}</p>
      <p class="get-at">獲得日時：{{ getAt }}</p>
      <p v-if="expiredAt" class="expired-at">有効期限：{{ expiredAt }}</p>
      <p v-if="data.is_over" class="is-over">獲得上限に達しました。</p>
    </div>
    <div v-if="canShowActionButton" class="action">
      <button @click="action(historyId)" :class="actionButtonDisabled && 'disabled'">{{ buttonLabel }}</button>
    </div>
    <div v-else-if="canShowStampImage" class="action">
      <img :src="data.image_path" alt="">
    </div>
  </div>
</template>

<script>
import { GACHA_PRIZE_TYPE, GACHA_TAB_TYPE } from '@/store/gacha'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GachaListCell',
  props: {
    data: { type: Object, required: true }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      selectedTab: 'Gacha/selectedTab'
    }),
    title() {
      return this.selectedTab.key === GACHA_TAB_TYPE.ticket.key ?
        this.data.gacha.name :
        this.data.name
    },
    getAt() {
      return moment(this.data.get_at).format(this.dateFormat)
    },
    expiredAt() {
      return this.selectedTab.key === GACHA_TAB_TYPE.ticket.key ?
        this.data.gacha ? moment(this.data.gacha.end_at).format(this.dateFormat) : '' :
        null
    },
    historyId() {
      return this.selectedTab.key === GACHA_TAB_TYPE.ticket.key ? this.data.id : null
    },
    buttonLabel() {
      if (this.selectedTab.key === GACHA_TAB_TYPE.ticket.key && this.data.is_over) {
        return '-'
      }
      return this.selectedTab.key === GACHA_TAB_TYPE.ticket.key ?
        'ガチャを引く' :
        this.data.use_at ? '使用済み' : 'つかう'
    },
    canShowActionButton() {
      return this.selectedTab.key === GACHA_TAB_TYPE.ticket.key ||
        (this.selectedTab.key === GACHA_TAB_TYPE.prize.key &&
          (this.data.prize_type === GACHA_PRIZE_TYPE.coupon || this.data.prize_type === GACHA_PRIZE_TYPE.prize))
    },
    canShowStampImage() {
      return this.selectedTab.key === GACHA_TAB_TYPE.prize.key && this.data.prize_type === GACHA_PRIZE_TYPE.stamp
    },
    actionButtonDisabled() {
      return (this.selectedTab.key === GACHA_TAB_TYPE.ticket.key && this.data.is_over) ||
        (this.selectedTab.key === GACHA_TAB_TYPE.prize.key && this.data.use_at)
    },
    dateFormat() {
      return `YYYY年M月D日${this.selectedTab.key === GACHA_TAB_TYPE.ticket.key ? ' HH:mm' : ''}`
    }
  },
  methods: {
    ...mapActions('Native', ['actionRequestExternalLink']),
    action(historyId) {
      if (this.selectedTab.key === GACHA_TAB_TYPE.ticket.key) {
        this.tryGacha(historyId)
      } else {
        this.actionRequestExternalLink('frbbscreen://coupon')
      }
    },
    tryGacha(historyId) {
      this.$emit('try-gacha', historyId)
    }
  }
}
</script>

<style lang="scss" scoped>
.list-cell-container {
  display: flex;
  padding: 20px 15px;
  border-bottom: 1px solid #dddddd;

  .content {
    width: 70%;
    padding-right: 15px;

    .title {
      color: #66160E;
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .get-at, .expired-at, .is-over {
      color: #999999;
      font-size: 12px;
    }

    .is-over {
      color: #dc000c;
    }
  }

  .action {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
    }

    button {
      width: 100%;
      display: block;
      background: #66160E;
      border-radius: 6px;
      padding: 10px;
      color: #ffffff;
      font-weight: bold;

      &.disabled {
        background-color: #bbbbbb;
        opacity: 1.0;
        pointer-events: none;
      }
    }
  }

}
</style>
